/* Native collection-card color swatches (Globo Color Swatch replacement)
   Swaps a product card's main image to the clicked/hovered color's
   variant image. Delegated at the document level so it works for every
   card on a collection grid without a per-card listener. */
(function () {
  'use strict';

  function swapImage(card, swatch) {
    // snippets/lazy-image.liquid puts the `class` param (which is how we
    // locate the card's main image) on the wrapping <figure>, not on the
    // <img> itself -- the <img> only gets `image_class` (unset here). So
    // the actual src/srcset live one level deeper than the figure.
    var figure = card.querySelector('.product-item__image-figure--top');
    if (!figure) return;
    var img = figure.tagName === 'IMG' ? figure : figure.querySelector('img');
    if (!img) return;

    var src = swatch.dataset.swapSrc;
    var srcset = swatch.dataset.swapSrcset;
    if (!src) return;

    img.src = src;
    if (srcset) img.srcset = srcset;

    card.querySelectorAll('[data-js-product-item-swatch]').forEach(function (el) {
      el.classList.remove('is-active');
    });
    swatch.classList.add('is-active');
  }

  function handle(e) {
    var swatch = e.target.closest && e.target.closest('[data-js-product-item-swatch]');
    if (!swatch) return;

    var card = swatch.closest('[data-js-product-item]');
    if (!card) return;

    if (e.type === 'click') {
      // Selecting a color previews it on the card; it shouldn't also
      // navigate via the card's full-card invisible link.
      e.preventDefault();
      e.stopPropagation();
    }

    swapImage(card, swatch);
  }

  document.addEventListener('click', handle);
  document.addEventListener('mouseover', handle);
})();
